<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-select
          label="Service Type"
          v-model="serviceType"
          :outlined="outlinedInputs"
          :items="serviceTypesItems"
        ></v-select>
      </v-col>
      <v-col>
        <department-list-select
          v-model="department"
          :outlined="outlinedInputs"
          show-all
        ></department-list-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <agent-group-select
          v-model="agentGroupId"
          :outlined="outlinedInputs"
          :groupsOnly="true"
        ></agent-group-select>
      </v-col>
      <v-col>
        <v-text-field
          v-model.number="commissionPercent"
          label="Commission Percent"
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="adultAmount"
          label="Adult Amount"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="childAmount"
          label="Child Amount"
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch v-model="notInUse" label="Not In Use"></v-switch>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn @click="onShowChangelogs">Logs</v-btn>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <changelogs-dialog
      v-if="value && value.id"
      :owner-id="value.id"
      :show="showChangelogs"
      @close="showChangelogs = false"
    />
    <v-row v-if="debug">
      <code>{{ value }}</code>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import DepartmentListSelect from "../../shared/DepartmentListSelect";
import AgentGroupSelect from "../../shared/AgentGroupSelect";
import ChangelogsDialog from "../../shared/ChangelogsDialog.vue";
import gql from "graphql-tag";
const ACTIVITY_TYPES = gql`
  query activityTypes {
    serviceTypes(supplierType: ACTIVITY) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
const SERVICE_TYPES = gql`
  query serviceTypes {
    activities: serviceTypes(supplierType: ACTIVITY) {
      edges {
        node {
          id
          name
        }
      }
    }
    accommodations: serviceTypes(supplierType: HOTELS) {
      edges {
        node {
          id
          name
        }
      }
    }
    transports: serviceTypes(supplierType: TRANSPORT) {
      edges {
        node {
          id
          name
        }
      }
    }
    travels: serviceTypes(supplierType: TRAVEL) {
      edges {
        node {
          id
          name
        }
      }
    }
    packages: serviceTypes(supplierType: PACKAGE) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  name: "commission-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    DepartmentListSelect,
    AgentGroupSelect,
    ChangelogsDialog,
  },

  data() {
    return {
      debug: false,
      serviceType: this.value ? this.value.serviceType : "",
      department: this.value ? this.value.department : "",
      agentGroupId: this.value ? this.value.groupId : "",
      commissionPercent: this.value ? this.value.commissionPercent : "",
      adultAmount: this.value ? this.value.adultAmount : "",
      childAmount: this.value ? this.value.childAmount : "",
      notInUse: this.value ? this.value.notInUse : false,
      showChangelogs: false,
    };
  },

  computed: {
    serviceTypesItems() {
      return this.serviceTypes
        ? [
            "Accommodation",
            "Activity",
            "Transport",
            "Travel",
            "Other",
            "Charge",
            ...this.serviceTypes.map((item) => item.node.name),
          ]
        : [];
    },
    editorTitle() {
      return `${this.value && this.value.id ? "Edit" : "Add"} - Commission`;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.serviceType != "" && this.department != "";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.serviceType = newVal.serviceType;
        this.department = newVal.department;
        this.agentGroupId = newVal.groupId;
        this.commissionPercent = newVal.commissionPercent;
        this.adultAmount = newVal.adultAmount;
        this.childAmount = newVal.childAmount;
        this.notInUse = newVal.notInUse;
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        serviceType: this.serviceType,
        department: this.department,
        agentGroupId: this.agentGroupId,
        commissionPercent: Number(this.commissionPercent),
        adultAmount: Number(this.adultAmount),
        childAmount: Number(this.childAmount),
        notInUse: this.notInUse,
      });
    },
    onShowChangelogs() {
      this.showChangelogs = true;
    },
  },

  apollo: {
    serviceTypes: {
      query: SERVICE_TYPES,
      update: (data) => [
        ...data.activities.edges,
        ...data.accommodations.edges,
        ...data.transports.edges,
        ...data.travels.edges,
        ...data.packages.edges,
      ],
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/commissions/CommissionEditDialog.vue